import React from 'react';
import {GestureResponderEvent, Pressable} from 'react-native';
import {faEye} from '@fortawesome/free-regular-svg-icons/faEye';
import {faEyeSlash} from '@fortawesome/free-regular-svg-icons/faEyeSlash';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

const TogglePasswordVisibleIconButton = ({
  onPress,
  isPasswordVisible,
}: {
  onPress: (event: GestureResponderEvent) => void;
  isPasswordVisible: boolean;
}) => (
  <Pressable onPress={onPress}>
    <FontAwesomeIcon
      icon={isPasswordVisible ? faEye : faEyeSlash}
      size={20}
      style={{color: 'lightgrey'}}
    />
  </Pressable>
);

export default TogglePasswordVisibleIconButton;
